<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 1
      h1 Revolución verde

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-6.col-md-9.mb-3.mb-lg-0
        img(src='@/assets/curso/temas/t1/1.png', alt='')
      .col-lg-6  
        p Constituyó un proceso de transformación agrícola orientado a incrementar de manera significativa la producción mundial de alimentos, con el propósito de mitigar el riesgo de hambrunas asociado al acelerado crecimiento demográfico. Este modelo productivo se sustentó en la incorporación sistemática de avances científicos y tecnológicos aplicados al sector agropecuario, tales como el uso de semillas mejoradas de alto rendimiento, fertilizantes sintéticos, agroquímicos, sistemas de riego tecnificado y mecanización agrícola, con el objetivo de maximizar la productividad por hectárea y optimizar la eficiencia de los sistemas de cultivo.  


    .subt.mb-4(data-aos="fade-right")
      img(src='@/assets/curso/temas/t1/subt.svg', alt='')
      h3.mb-0.p-3.ps-lg-4.pe-lg-5 Orígenes históricos 

    p La revolución verde fue un proceso de transformación agrícola que inició a mediados del siglo XX, principalmente entre las décadas de 1940 y 1970. 

    .row.bgc-1.align-items-center.p-2.p-md-3.pt-5.pt-md-5.mb-4(data-aos="fade-down")
      .col-lg-12.col-12.px-lg-4
        .row.justify-content-center.align-items-center

          .col-12
            LineaTiempoE.color-acento-contenido.mb-5
              .row(titulo="1940." subtitulo="Inicio del proceso.")
                .col-lg-6.order-2.order-lg-1
                  ul.lista-ul--color.color-primario.fa-lista
                    li
                      i.fas.fa-check
                      span.mb-0 Comienzan programas de investigación agrícola en México orientados a mejorar la productividad del trigo. 
                    li
                      i.fas.fa-check
                      span.mb-0 Se establecen bases científicas para el desarrollo de semillas de alto rendimiento. 
                .col-lg-6.col-md-10.mb-3.mb-lg-0.order-1.order-lg-2
                  img(src='@/assets/curso/temas/t1/linea1-1.png', alt='')
              .row(titulo="Década de 1950." subtitulo="Innovación científica.")
                .col-lg-6.col-md-10.mb-3.mb-lg-0
                  img(src='@/assets/curso/temas/t1/linea1-2.png', alt='')     
                .col-lg-6.mb-4.mb-lg-0
                  ul.lista-ul--color.color-primario.fa-lista
                    li
                      i.fas.fa-check
                      span.mb-0 El agrónomo estadounidense #[b Norman Borlaug] desarrolla variedades mejoradas de trigo resistentes y de alto rendimiento. 
                    li
                      i.fas.fa-check
                      span.mb-0 Se registran incrementos significativos en la producción agrícola mexicana. 
              .row(titulo="Década de 1960." subtitulo="Impulso internacional.")
                .col-lg-6.order-2.order-lg-1
                  ul.lista-ul--color.color-primario.fa-lista
                    li
                      i.fas.fa-check
                      span.mb-0 La #[b Fundación Rockefeller] respalda programas de investigación agrícola. 
                    li
                      i.fas.fa-check
                      span.mb-0 Organismos multilaterales como el #[b Banco Mundial] promueven la transferencia tecnológica hacia países en desarrollo. 
                .col-lg-6.col-md-10.mb-3.mb-lg-0.order-1.order-lg-2
                  img(src='@/assets/curso/temas/t1/linea1-3.png', alt='')
              .row(titulo="1960 - 1970." subtitulo="Expansión global.")
                .col-lg-6.col-md-10.mb-3.mb-lg-0
                  img(src='@/assets/curso/temas/t1/linea1-4.png', alt='')     
                .col-lg-6.mb-4.mb-lg-0
                  ul.lista-ul--color.color-primario.fa-lista
                    li
                      i.fas.fa-check
                      span.mb-0 El modelo se expande hacia Asia y América Latina. 
                    li
                      i.fas.fa-check
                      span.mb-0 Se incorporan semillas híbridas, fertilizantes químicos, pesticidas, mecanización agrícola y riego intensivo. 
          
          .col-lg-7      
            .cajon.color-primario.bg1.p-4
              p.mb-0 La revolución verde priorizó el aumento de la productividad por hectárea como principal indicador de éxito agrícola. 

      
      Separador
      #t_1_1.titulo-segundo.color-acento-contenido(data-aos='fade-right')
        h2 1.1  Principales características 
 
      p La revolución verde se caracterizó por la implementación de un modelo agrícola intensivo basado en la modernización tecnológica y la estandarización de los sistemas productivos. 
      p Sus principales características son:  

      .row.justify-content-center.mb-4
        .col-lg-8(data-aos="fade-right")
          AcordionA(tipo="b" clase-tarjeta="tarjeta bg2")
            .row(titulo="Uso de semillas mejoradas de alto rendimiento")
              .col-md-11
                p.mb-0 Se desarrollaron variedades híbridas y posteriormente variedades genéticamente mejoradas capaces de producir mayores volúmenes por hectárea, especialmente en cultivos como trigo, arroz y maíz. 
            .row(titulo="Dependencia de insumos químicos")
              .col-md-11
                p.mb-0 El modelo promovió el uso masivo de fertilizantes sintéticos, herbicidas e insecticidas para maximizar la productividad y controlar plagas y enfermedades. 
            .row(titulo="Mecanización agrícola")
              .col-md-11
                p.mb-0 Se incorporó maquinaria pesada para la preparación del suelo, siembra y cosecha, reduciendo la mano de obra y aumentando la escala de producción. 
            .row(titulo="Riego tecnificado")
              .col-md-11
                p.mb-0 Se impulsaron grandes sistemas de irrigación para garantizar la disponibilidad de agua durante todo el ciclo productivo. 
            .row(titulo="Especialización y monocultivo")
              .col-md-11
                p.mb-0 Se priorizó la siembra de una sola especie en grandes extensiones, favoreciendo la eficiencia productiva, pero reduciendo la diversidad agrícola. 
            .row(titulo="Integración al mercado global")
              .col-md-11
                p.mb-0 La producción se orientó hacia mercados nacionales e internacionales, fortaleciendo cadenas agroindustriales. 
        .col-lg-4.d-none.d-lg-block(data-aos="fade-left")
          img(src='@/assets/curso/temas/t1/2.png', alt='')

      .row.justify-content-center
        .col-lg-7
          .cajon.color-primario.bg1.p-4
            p.mb-0 Estas características consolidaron un modelo productivo altamente dependiente de capital e insumos externos. 


      Separador
      #t_1_2.titulo-segundo.color-acento-contenido(data-aos='fade-right')
        h2 1.2 Logros productivos y problemáticas ambientales

      p Desde el punto de vista productivo, la revolución verde generó resultados significativos, entre ellos: 

      .row.justify-content-center.no-pointer.mb-4(data-aos="fade")
        .col-lg-3.col-md-6.mb-3
          .tarjeta--boton.color-acento-botones.h-100.p-4
            .row.justify-content-center.mb-3
              .col-6.col-md-7.col-lg-7.mb-4
                img(src='@/assets/curso/temas/t1/tarj1-1.png', alt='')
              h4.text-center Incremento en rendimientos agrícolas
              p.mb-0 Los rendimientos de cereales como trigo y arroz aumentaron considerablemente, contribuyendo a reducir el riesgo inmediato de hambrunas en varios países. 
        .col-lg-3.col-md-6.mb-3
          .tarjeta--boton.color-acento-botones.h-100.p-4
            .row.justify-content-center.mb-3
              .col-6.col-md-7.col-lg-7.mb-4
                img(src='@/assets/curso/temas/t1/tarj1-2.png', alt='')
              h4.text-center Disminución de precios relativos de alimentos
              p.mb-0 El aumento de la oferta permitió estabilizar mercados y mejorar la disponibilidad alimentaria.
        .col-lg-3.col-md-6.mb-3
          .tarjeta--boton.color-acento-botones.h-100.p-4
            .row.justify-content-center.mb-3
              .col-6.col-md-7.col-lg-7.mb-4
                img(src='@/assets/curso/temas/t1/tarj1-3.png', alt='')
              h4.text-center Modernización tecnológica
              p.mb-0 Se fortaleció la investigación agrícola y la transferencia tecnológica en numerosos países en desarrollo. 
        .col-lg-3.col-md-6.mb-3
          .tarjeta--boton.color-acento-botones.h-100.p-4
            .row.justify-content-center.mb-3
              .col-6.col-md-7.col-lg-7.mb-4
                img(src='@/assets/curso/temas/t1/tarj1-4.png', alt='')
              h4.text-center Impulso a la agroindustria
              p.mb-0 Se consolidaron cadenas productivas y sistemas de comercialización más estructurados.

      .row.justify-content-center.mb-5
        .col-lg-7
          .cajon.color-primario.bg1.p-4
            p.mb-0 Sin embargo, estos logros estuvieron acompañados de impactos no previstos que afectaron la sostenibilidad a largo plazo. 

      .subt.mb-4(data-aos="fade-right")
        img(src='@/assets/curso/temas/t1/subt.svg', alt='')
        h3.mb-0.p-3.ps-lg-4.pe-lg-5 Problemáticas ambientales 

      p.mb-4 El modelo de la revolución verde generó múltiples impactos ambientales derivados del uso intensivo de recursos naturales y agroquímicos, algunos de ellos fueron:  

      .row.justify-content-center.mb-4
        .col-lg-7(data-aos="fade-right")
          ul.lista-ul--color.lista-ul--separador.color-adicional-2.fa-lista.mb-4
            li
              i.fas.fa-spa
              span.mb-0 Degradación del suelo: el uso continuo de fertilizantes sintéticos alteró la estructura biológica del suelo, reduciendo su materia orgánica y biodiversidad microbiana. 
            li
              i.fas.fa-spa
              span.mb-0 Contaminación de fuentes hídricas: el escurrimiento de nitratos y fosfatos provenientes de fertilizantes generó eutrofización en ríos y lagos. 
            li
              i.fas.fa-spa
              span.mb-0 Pérdida de biodiversidad: la sustitución de variedades tradicionales por monocultivos redujo la diversidad genética agrícola. 
            li
              i.fas.fa-spa
              span.mb-0 Dependencia energética: la producción intensiva aumentó el consumo de combustibles fósiles, contribuyendo a la emisión de gases de efecto invernadero.
            li
              i.fas.fa-spa
              span.mb-0 Salinización y desertificación: en zonas con riego intensivo, el manejo inadecuado provocó acumulación de sales y degradación irreversible del suelo. 
          .cajon.color-primario.bg1.p-4
            p.mb-0 La productividad a corto plazo no consideró la capacidad de carga ecológica de los ecosistemas. 
        .col-lg-5.d-none.d-lg-block(data-aos="fade-left")
          img(src='@/assets/curso/temas/t1/3.png', alt='')


      Separador
      #t_1_3.titulo-segundo.color-acento-contenido(data-aos='fade-right')
        h2 1.3 Impactos y cuestionamientos al modelo agrícola convencional
      
      p El análisis del modelo agrícola convencional requiere una mirada integral que permita comprender no solo sus resultados productivos, sino también sus efectos sociales y económicos, así como los cuestionamientos que han surgido frente a su sostenibilidad.  
      p.mb-4 Resulta pertinente examinar tanto sus impactos estructurales como las principales críticas formuladas desde enfoques alternativos de desarrollo rural. 

      .row.justify-content-center
        .col-lg-6.mb-3(data-aos="fade-right")
          .bg1.tarjeta.h-100.p-4
            .subt-cuad.mb-4
              h4.mb-0.p-3.ps-5 Impactos sociales y económicos 
            p Aunque la revolución verde incrementó la producción de alimentos, sus beneficios no se distribuyeron equitativamente, por ejemplo: 
            ul.lista-ul--color.fa-lista
              li
                i.fas.fa-spa
                span.mb-0 Concentración de la tierra: los pequeños productores tuvieron dificultades para acceder a créditos, semillas mejoradas y maquinaria, favoreciendo a grandes propietarios. 
              li
                i.fas.fa-spa
                span.mb-0 Endeudamiento campesino: la dependencia de insumos externos generó altos costos de producción.
              li
                i.fas.fa-spa
                span.mb-0 Desplazamiento rural: la mecanización redujo la demanda de mano de obra, impulsando migraciones hacia zonas urbanas. 
              li
                i.fas.fa-spa
                span.mb-0 Pérdida de saberes tradicionales: el modelo técnico reemplazó prácticas agrícolas ancestrales. 
              li
                i.fas.fa-spa
                span.mb-0 Aumento de desigualdad: se amplió la brecha entre agricultura empresarial y agricultura campesina.
        .col-lg-6.mb-3(data-aos="fade-left")
          .bg3.tarjeta.h-100.p-4
            .subt-cuad.mb-4
              h4.mb-0.p-3.ps-5 Críticas al modelo convencional 
            p Diversos movimientos sociales, académicos y ambientales comenzaron a cuestionar el modelo convencional debido principalmente a: 
            ul.lista-ul--color.fa-lista.mb-4
              li
                i.fas.fa-spa
                span.mb-0 Su enfoque exclusivamente productivista. 
              li
                i.fas.fa-spa
                span.mb-0 La pérdida de autonomía de los agricultores. 
              li
                i.fas.fa-spa
                span.mb-0 La degradación ambiental acumulativa.
              li
                i.fas.fa-spa
                span.mb-0 La homogenización cultural y agrícola. 
            p Estos cuestionamientos dieron origen a enfoques alternativos como la agroecología, la agricultura orgánica y los movimientos de soberanía alimentaria impulsados por organizaciones como “La Vía Campesina”. 


</template>

<script>
export default {
  name: 'Tema1',
  data: () => ({
    mostrarIndicadorTarjetaAudio: true,
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
